import { CheckedChangedEventHandler, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import ListFilterItem from '@/scopes/search/search/pages/SearchPage/components/Filters/ListFilterItem'

const Wrapper = styled.div`
    padding-top: ${tokPx('primitives_space_8')};
`

export function BathroomCountFilter() {
  const intl = useIntl()
  const { options, selectedValue, isFetching, setSelection } = useSelectFilter('BathroomCount')
  const { sendEvent } = useAnalytics()

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'bathroom count',
          result: value,
        }),
      )
    }
    else {
      setSelection(undefined)
    }
  }
  if (isEmpty(options))
    return null

  return (
    <Wrapper data-qa="bathroom-count-filter">
      <Typography variant="body-m-regular-snug" forwardedAs="h3" className="my-2">
        {intl.formatMessage({ id: 'search_filter_bathroom_count_label' })}
      </Typography>
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
        visibleItems={4}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ListFilterItem.Checkbox
            key={name}
            label={name}
            counter={resultsCount}
            checked={selectedValue === value}
            value={value}
            onChange={handleFilterChange}
            disabled={isFetching}
            data-qa="bathroom-count-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </ShowMore>
    </Wrapper>
  )
}
